enum ActionTypes {
  CREATE_SIGNATURE = 'Signature/CREATE_SIGNATURE',
  CREATE_SIGNATURE_REQUEST = 'Signature/CREATE_SIGNATURE_REQUEST',
  CREATE_SIGNATURE_SUCCESS = 'Signature/CREATE_SIGNATURE_SUCCESS',
  CREATE_SIGNATURE_FAILURE = 'Signature/CREATE_SIGNATURE_FAILURE',
}

export default ActionTypes;
